import { Record as record } from 'immutable';

import trainTime from '../../../../src/lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, resolve, resolveAll, fields } from '../../../../src/helpers/LinkMapper';

const timeFactory = (time) => {
    const [ hours, minutes ] = time.split(/:/);
    return trainTime.duration({ hours, minutes });
};

const fieldSchema = {
    departureDate: [ resolve.with(trainTime) ],
    departureTime: [ resolve.with(timeFactory) ],
    scheduledArrivalDate: [ resolve.with(trainTime) ],
    scheduledArrivalTime: [ resolve.with(timeFactory) ],
    originStation: [ fields.string ],
    originStationName: [ fields.string ],
    destinationStation: [ fields.string ],
    destinationStationName: [ fields.string ],
    changeStation: [ resolveAll.with(String) ]
};

export default class DelayRepayJourney extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(DelayRepayJourney, json, getResolvers(fieldSchema));
    }

    get departureDateTime () {
        return this.departureDate && this.departureDate.clone().add(this.departureTime);
    }

    get arrivalDateTime () {
        return this.scheduledArrivalDate &&
            this.scheduledArrivalDate.clone().add(this.scheduledArrivalTime);
    }

}
